module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNav),
      expression: "showNav"
    }],
    staticClass: "navBread"
  }, [_c('router-link', {
    staticClass: "match",
    attrs: {
      "to": {
        path: _vm.jumpUrl
      }
    }
  }, [_vm._v(_vm._s(_vm.firstTitle))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: _vm.subJumpUrl
      }
    }
  }, [_vm._v(_vm._s(_vm.subtitle))])], 1), _vm._v(" "), _c('header', {
    staticClass: "pad15"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('div', [(!_vm.afhao || _vm.afhao.length === 0 || JSON.stringify(_vm.afhao) === '{}') ? _c('h2', [_c('time', [_vm._v(_vm._s(_vm.time))]), _vm._v("\n                  /  "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.writer)
    }
  })]) : _c('div', {
    staticClass: "afHao clearfix"
  }, [_c('dl', {
    staticClass: "userInfor"
  }, [_c('dt', [_c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.afhao.avatar)
    }
  })]), _vm._v(" "), _c('dd', [_c('p', [_vm._v(_vm._s(_vm.afhao.name))]), _vm._v(" "), _c('p', {
    staticClass: "afhTime"
  }, [_vm._v(_vm._s(_vm.time))])])]), _vm._v(" "), _c('a', {
    staticClass: "afh_follow",
    class: {
      'grayWord': Number(_vm.afhao.follow_status) === 1
    },
    on: {
      "click": function($event) {
        _vm.afhFollow(_vm.afhao)
      }
    }
  }, [_vm._v(_vm._s(Number(_vm.afhao.follow_status) === 0 ? _vm.$t('Follow') : _vm.$t('Following')))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-755db196","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/headerTitle.vue
// module id = 718
// module chunks = 1